module.exports = __webpack_public_path__ + "assets/1a4188f57122cc40f05bc4d21cb5ac24.png";